import * as Log from "web-ui/log"

export function DropdownCloseOnScrollPlugin() {
  const tomSelect = this

  let scrollPositions = new Map()

  tomSelect.on("dropdown_open", () => {
    scrollPositions = getControlScrollPositions()

    window.addEventListener("scroll", closeDropdownOnScroll, true)

    tomSelect.dropdown_content.addEventListener("wheel", preventBodyScroll, { passive: false })
  })

  tomSelect.on("dropdown_close", () => {
    window.removeEventListener("scroll", closeDropdownOnScroll, true)

    tomSelect.dropdown_content.removeEventListener("wheel", preventBodyScroll)
  })

  function preventBodyScroll(e) {
    const dropdown = e.currentTarget
    const scrollTop = dropdown.scrollTop

    const atTop = scrollTop === 0

    const height = dropdown.clientHeight
    const scrollHeight = dropdown.scrollHeight
    const atBottom = scrollTop + height >= scrollHeight

    const deltaY = e.deltaY

    const isScrollingUp = deltaY < 0
    const isScrollingDown = deltaY > 0

    if ((isScrollingUp && atTop) || (isScrollingDown && atBottom)) {
      e.preventDefault()
    }
  }

  function closeDropdownOnScroll(e) {
    const target = e.target
    const targetId = target.id
    const tagName = target.tagName

    debug("Scrolling", { target, tagName, targetId })

    const previousScrollPosition = scrollPositions.get(target)

    if (!previousScrollPosition) {
      return
    }

    const currentScrollPosition = getCurrentScrollPosition(target)

    scrollPositions.set(target, currentScrollPosition)

    const verticalScrollChanged = previousScrollPosition.top !== currentScrollPosition.top

    if (!verticalScrollChanged) {
      return
    }

    debug("Closing dropdown")

    tomSelect.close()
    tomSelect.blur()
  }

  function getCurrentScrollPosition(target) {
    if (target === document || target === document.documentElement || target === document.body) {
      return {
        top: window.scrollY,
        left: window.scrollX
      }
    } else {
      return {
        top: target.scrollTop || 0,
        left: target.scrollLeft || 0
      }
    }
  }

  function getControlScrollPositions() {
    const positions = new Map()

    positions.set(document, getCurrentScrollPosition(document))

    let element = tomSelect.control.parentElement
    while (element) {
      positions.set(element, getCurrentScrollPosition(element))

      element = element.parentElement
    }

    return positions
  }

  function debug(message, data={}) {
    Object.assign(data, {
      id: tomSelect.input.id
    })

    Log.debug("Close Dropdown On Scroll Plugin - " + message, data)
  }
}
